import { compose } from 'recompose';

import ModaleWindowView from './ModaleWindowView';

export default compose()(ModaleWindowView);
